import { Button } from "@fluentui/react-components";
import { AttachRegular } from "@fluentui/react-icons";
import { useRef } from "react";
import { useIntl } from "react-intl";
import { DropFilesOverlay } from "./DropFilesOverlay";
import { messagingAllowedExtensions } from "./types";
import { useMessagingDrop } from "./useMessagingDrop";

interface MessagingComposerShellProps {
	processFiles: (files: File[]) => void | Promise<void>;
	allowAttachments: boolean;
	isDisabled?: boolean;
	children: React.ReactNode;
}

export const MessagingComposerShell: React.FC<MessagingComposerShellProps> = ({
	processFiles,
	allowAttachments,
	isDisabled,
	children,
}) => {
	const intl = useIntl();
	const fileInputRef = useRef<HTMLInputElement>(null);
	const { isDragActive, containerProps, sendboxRelativeClass } =
		useMessagingDrop(processFiles, !allowAttachments || isDisabled);

	const handleFileUploadClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	const handleFileChange = async (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		await processFiles(Array.from(event.target.files ?? []));
		event.target.value = "";
	};

	return (
		<div id="sendbox" {...containerProps}>
			<div className={sendboxRelativeClass}>
				{isDragActive && <DropFilesOverlay />}
				{children}
			</div>
			{allowAttachments && (
				<>
					<input
						type="file"
						accept={messagingAllowedExtensions.join(",")}
						multiple
						ref={fileInputRef}
						style={{ display: "none" }}
						onChange={handleFileChange}
					/>
					<Button
						style={{
							marginLeft: "4px",
							marginBottom: "10px",
						}}
						onClick={handleFileUploadClick}
						disabled={isDisabled}
						icon={
							<AttachRegular
								fontSize={22}
								color="grey"
								style={{
									cursor: "pointer",
								}}
							/>
						}
					>
						{intl.formatMessage({
							id: "Interaction.WhatsAppContent.AttachFile",
						})}
					</Button>
				</>
			)}
		</div>
	);
};
